<template xmlns="http://www.w3.org/1999/html">

    <section class="help">
        <div class="panel">
            <div class="panel-heading"><h2>Documentation<i class="clippie fa fa-info-circle" v-tooltip="'Documents and articles pertaining to Portal, required software and hot tips (check back often!)'"></i></h2></div>
            <div class="panel-body" v-if="rootPage">
                <h3 :class="rootPage.slug">
                    <router-link :to="{name: 'help-page', params: {slug: rootPage.slug}}">
                        {{rootPage.title}}
                    </router-link>
                </h3>

                <ul class="pages list-group">
                <li><router-link :to="{name: 'software-keys'}">Software Keys</router-link></li>
                <li v-for="page in rootPage.childPages" class="list-group-item" :class="page.slug">

                        <router-link v-if="page.slug=='software-installation'" :to="{name: 'software-installation'}">
                            {{page.title}}
                        </router-link>

                        <router-link v-else :to="{name: 'help-page', params: {slug: page.slug}}">
                            {{page.title}}
                        </router-link>

                        <ul v-if="isSoftwarePage && page.childPages" class="list-group">
                            <li v-for="childPage in page.childPages" :class="childPage.slug" class="list-group-item">
                                <router-link :to="{name: 'help-page', params: {slug: childPage.slug}, query: {software_page:true}}">
                                    {{childPage.title}}
                                </router-link>

                            </li>
                        </ul>

                    </li>
                </ul>
            </div>
            <div v-else>
                <Loader></Loader>
            </div>

        </div>

</section>

</template>


<script>
    import support from '../../services/support';
    import Loader from './../reusable/forum/loader.vue';

    export default {
        data() {
            return {
                rootPage: null,
                isSoftwarePage: false
            }
        },
        components: {
            Loader
        },
        mounted() {
            this.getHelp();
            if (this.$route.query.software_page) this.isSoftwarePage = true;
        },
        methods: {
            getHelp() {
                var self = this;
                support.getHelp(this).then(function(response) {
                    var pages = response.data.pages;
                    var index = pages.findIndex(function(p) { return p.slug === 'help-for-students'});
                    var rootPage = pages[index];
                    rootPage.childPages = [];

                        rootPage.children.forEach(function(page, index) {
                            let i = pages.findIndex(function(p) { return p.id === page});
                            let childPage = pages[i];

                            if (childPage.children.length > 0) {
                                childPage.childPages = [];
                                childPage.children.forEach(function(child) {
                                    let j = pages.findIndex(function(p) { return p.id === child});
                                    childPage.childPages.push(pages[j]);
                                });
                            }
                            rootPage.childPages.push(childPage);

                        });
                    self.rootPage = rootPage;
                });
            }
        }
    }

</script>

<style lang="scss" scoped>

    ul, li, h3 {
        font-size:2rem!important;
        font-weight: 100;
        padding:0;
        margin:0 0 10px 0!important;
    }


    ul.pages {

        padding-left:1rem;
        ul {
            padding-left:1rem;
        }
    }

    .list-group-item {
        margin-bottom: 10px;
        border:none;
        padding:0;
    }
</style>

<style lang="scss">

.help-page {
    .panel-body {
        padding:20px!important;
    }
}
    section.support .panel-body {
        h2 {
            background:transparent;
        }
        ul {
         list-style-type:disc!important;
         padding-left:2rem;

         li {
            list-style-type:disc!important;
        }

    }
}

.router-link-active {
    color:white;
}

.list-group-item a:hover {color:white;}

.children-help {
    display: none!important;
}

h5 {
    font-size:16px!important;
}

h6 {
    font-size:14px!important;
    font-weight: 600!important;
    color:#ccc!important;
}

</style>



// WEBPACK FOOTER //
// Help.vue?4514dd56